import { render, staticRenderFns } from "./DualList.vue?vue&type=template&id=7b1a8850&scoped=true&"
import script from "./DualList.vue?vue&type=script&lang=js&"
export * from "./DualList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1a8850",
  null
  
)

export default component.exports